import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { StandardModalHeader } from "@design-system/Modal/Modal";
import { FC, useState } from "react";
import { OrganizationAvatar } from "@components/avatar/OrganizationAvatar";
import { OrganizationIdNameLogoUrl } from "@common/schemas/organization.schema";
import styles from "./ConfirmOrganizationsModal.module.scss";

interface Props {
    organizations: OrganizationIdNameLogoUrl[];
    onCancel: () => void;
    onConfirm: () => Promise<void>;
}

export const ConfirmOrganizationsModal: FC<Props> = ({
    organizations,
    onCancel,
    onConfirm,
}) => {
    const [loading, setLoading] = useState(false);
    return (
        <>
            <StandardModalHeader>
                We’ve found an organization linked to this invite
            </StandardModalHeader>

            <main className={styles.main}>
                <p className={styles.info}>
                    Inviting organizations includes all their members.
                </p>

                <section className={styles.organizations}>
                    {organizations.map((organization) => (
                        <div
                            key={organization.id}
                            className={styles.organizationCard}
                        >
                            <OrganizationAvatar
                                organization={organization}
                                size="xs"
                                aria-hidden
                            />
                            <span>{organization.name}</span>
                        </div>
                    ))}
                </section>

                <footer className={styles.footer}>
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={onCancel}
                        size="xl"
                        disabled={loading}
                    >
                        Back
                    </Button>
                    <ButtonWithLoader
                        variant="primary"
                        onClick={onConfirm}
                        loading={loading}
                        setLoading={setLoading}
                        size="xl"
                    >
                        Confirm
                    </ButtonWithLoader>
                </footer>
            </main>
        </>
    );
};
